<template>
    <div class="index">
        <div class="top-head">
            <img src="../../assets/imgs/center/bg-index.jpg" style="width:100%;">
            <div style="width: 1190px;position: absolute;top: 0px;left:50%;transform:translateX(-50%);height: 100%;min-heigh:300px;">
                <div class="section-content">
                    <img src="../../assets/imgs/center/prev.png" style="left: 0px;"/>
                    <img src="../../assets/imgs/center/next.png" style="right: 0px;"/>
                    <div class="circle-box flexBox">
                         <router-link tag="div" to="/center-principle" class="circle grad">
                            <p>设计</p>
                            <p>原理</p>
                        </router-link>
                        <router-link tag="div" to="/center-grad" class="circle grad">
                            <p>不断求新</p>
                            <p>的环境</p>
                        </router-link>
                        <div class="circle grad">
                            <p>中心</p>
                            <p>地址</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
         <div class="section-content centerMap">
            <div class="title">中心地址:</div>
            <router-link v-for="(item,i) in arr" :key="i" tag="div" :to="{path:'/center-map',query:{city: item}}" :class="{city:true,gray: item!=province,grad:  item==city}">{{item}}</router-link>
         </div>

    </div>
</template>
<script>
    export default {
         data(){
             return{
                 province: '',
                 arr:[],
             }
         },
        created(){
             this.$http.get('https://q.qitianzhen.cn/api/province_list').then(res=>{
                 this.arr = res.body.list;
             })
        },
        methods:{

        }
    }
</script>
<style lang="less" scoped>
    .index{
        .top-head{
            /*background: url('../../assets/imgs/center/bg-index.png') 100% 100% no-repeat;*/
            /*height: 890px;*/
            min-height:300px;
            position: relative;
            .section-content{
                height: 100%;
                position: relative;
                color: #ffffff;
                font-weight: 600;
                font-size: 30px;
                &>img{
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 130px;
                }
                .circle-box{
                    width: 800px;
                    height: 100%;
                    margin: 0px auto;
                    align-items: center;

                    .circle{
                        width: 200px;
                        height: 200px;
                        border-radius: 50%;
                        border: 4px solid #ffffff;
                        cursor: pointer;
                        text-align: center;
                        p{line-height: 32px;}
                        p:first-child{
                            margin-top: 68px;
                        }
                        &:hover{
                            color: #c6b196;
                        }
                    }
                }

            }
        }
         .centerMap{
             width:1090px;
             padding-bottom: 60px;
             font-size: 22px;
             font-weight: normal;
             .title{
                 color: #5e5e5e;
                 font-size: 24px;
                 font-weight: 600;
                 margin: 43px 0px 20px;
             }
             .city{
                 display: inline-block;
                 width: 202px;
                 height: 50px;
                 line-height: 50px;
                 text-align: center;
                 margin-right: 20px;
                 margin-bottom: 20px;
                 cursor: pointer;
                 &:hover{
                     color: #ffffff;
                     font-weight: 600;
                     background: -webkit-linear-gradient(left top, #fbad27, #fec006); /* Safari 5.1 - 6.0 */
                     background: -o-linear-gradient(bottom right, #fbad27, #fec006); /* Opera 11.1 - 12.0 */
                     background: -moz-linear-gradient(bottom right, #fbad27, #fec006); /* Firefox 3.6 - 15 */
                     background: linear-gradient(to bottom right, #fbad27, #fec006); /* 标准的语法 */
                 }
                 &:nth-child(5n+1){
                     margin-right: 0px;
                 }
             }
         }
        .gray{
            background: #eeeeee;
            color: #b9b9b9;
        }
        .grad {
            color: #ffffff;
            font-weight: 600;
            background: -webkit-linear-gradient(left top, #fbad27, #fec006); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom right, #fbad27, #fec006); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom right, #fbad27, #fec006); /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom right, #fbad27, #fec006); /* 标准的语法 */
        }
    }
</style>

